"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/web.dom.iterable");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _shopList = require("@/api/shop/shopList");
var _tableList = require("@/api/table/tableList");
var _memberManagement = require("@/api/member/memberManagement");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'guestManagement',
  data: function data() {
    var _this = this;
    // 自定义验证：结束代码必须大于等于开始代码
    var validateEndCode = function validateEndCode(rule, value, callback) {
      if (value && _this.fastTableForm.startCode && value < _this.fastTableForm.startCode) {
        callback(new Error('结束代码不能小于开始代码'));
      } else {
        callback();
      }
    };
    return {
      // 搜索表单数据
      searchForm: {
        storeId: '',
        template: '',
        page: 1,
        limit: 10
      },
      // 表格数据
      tableData: [],
      storeList: [],
      // 分页相关
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableLoading: false,
      // 抽屉相关
      drawerVisible: false,
      drawerTitle: '',
      drawerForm: {
        id: null,
        storeName: '',
        seatName: '',
        seatArea: '',
        capacity: '',
        saleMode: '',
        qrCodeFile: null
      },
      // 文件上传
      fileList: [],
      // 表单验证规则
      formRules: {
        storeName: [{
          required: true,
          message: '请选择店面',
          trigger: 'change'
        }],
        seatName: [{
          required: true,
          message: '请输入客位名称',
          trigger: 'blur'
        }],
        seatArea: [{
          required: true,
          message: '请输入客位区域',
          trigger: 'blur'
        }],
        capacity: [{
          required: true,
          message: '请输入容纳人数',
          trigger: 'blur'
        }, {
          pattern: /^[1-9]\d*$/,
          message: '请输入有效的人数',
          trigger: 'blur'
        }],
        saleMode: [{
          required: true,
          message: '请输入销售方式',
          trigger: 'blur'
        }]
      },
      // 店面选项
      storeOptions: [{
        label: '组织机构',
        value: 'headquarters'
      }, {
        label: '分店A',
        value: 'branchA'
      }, {
        label: '分店B',
        value: 'branchB'
      }],
      // 现有区域列表
      existingAreas: [],
      // 导入相关
      importDialogVisible: false,
      selectedFile: null,
      // 创建快餐客位码相关
      areaSelectDialogVisible: false,
      // 区域选择对话框
      fastTableDialogVisible: false,
      // 参数设置对话框
      fastTableCreating: false,
      areaList: [],
      // 区域列表
      selectedArea: null,
      // 选中的区域
      creatingArea: false,
      // 创建区域中
      newAreaForm: {
        areaName: ''
      },
      newAreaFormRules: {
        areaName: [{
          required: true,
          message: '请输入区域字母',
          trigger: 'blur'
        }, {
          pattern: /^[A-Z]$/,
          message: '只能输入一个大写字母（A-Z）',
          trigger: 'blur'
        }]
      },
      fastTableForm: {
        storeId: '',
        area: '',
        startCode: 1,
        endCode: 20,
        excludeCodesText: '',
        prefix: '',
        skipExisting: true
      },
      fastTableFormRules: {
        startCode: [{
          required: true,
          message: '请输入开始代码',
          trigger: 'blur'
        }, {
          type: 'number',
          min: 1,
          message: '代码必须大于0',
          trigger: 'blur'
        }],
        endCode: [{
          required: true,
          message: '请输入结束代码',
          trigger: 'blur'
        }, {
          type: 'number',
          min: 1,
          message: '代码必须大于0',
          trigger: 'blur'
        }, {
          validator: validateEndCode,
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.handleSearch();
    this.getShops();
  },
  methods: {
    // 搜索
    handleSearch: function handleSearch() {
      this.currentPage = 1; // 重置为第一页
      this.getList();
    },
    getList: function getList() {
      var _this2 = this;
      // if(this.searchForm.storeName===''||this.searchForm.storeName===null){
      //   this.$message.error('请选择门店')
      //   return;
      // }
      this.tableLoading = true;
      this.searchForm.page = this.currentPage;
      this.searchForm.limit = this.pageSize;

      // 查询门店信息
      (0, _tableList.getTableList)(this.searchForm).then(function (res) {
        _this2.tableData = res.records;
        _this2.total = res.total;
        _this2.tableLoading = false;
      });
    },
    sharedFood: function sharedFood(value, tableId) {
      var _this3 = this;
      console.log(value, tableId);
      var params = {
        tableId: tableId,
        share: value ? 1 : 0
      };
      (0, _tableList.updateTable)(params).then(function () {
        _this3.$message.success('修改成功');
      });
    },
    getShops: function getShops() {
      var _this4 = this;
      (0, _shopList.getStoreAllData)().then(function (res) {
        console.log(res.data);
        _this4.storeList = res.data;
      });
    },
    // 下载二维码
    downloadTemplate: function () {
      var _downloadTemplate = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this5 = this;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.searchForm.storeId) {
                _context.next = 1;
                break;
              }
              this.$message.warning('请先选择门店');
              return _context.abrupt("return");
            case 1:
              this.$message.success('模板下载中...');
              (0, _tableList.imageExport)({
                storeId: this.searchForm.storeId,
                template: this.searchForm.template
              }).then(function () {
                _this5.$message.success('模板下载成功');
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function downloadTemplate() {
        return _downloadTemplate.apply(this, arguments);
      }
      return downloadTemplate;
    }(),
    // 下载导入模板
    downloadImportTemplateFile: function () {
      var _downloadImportTemplateFile = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response, blob, link, _t;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return (0, _tableList.downloadImportTemplate)();
            case 1:
              response = _context2.sent;
              // 创建下载链接
              blob = new Blob([response], {
                type: 'application/vnd.ms-excel'
              });
              link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = '客位信息导入模板.xlsx';
              link.click();
              window.URL.revokeObjectURL(link.href);
              this.$message.success('导入模板下载成功');
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t = _context2["catch"](0);
              this.$message.error('导入模板下载失败: ' + _t.message);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function downloadImportTemplateFile() {
        return _downloadImportTemplateFile.apply(this, arguments);
      }
      return downloadImportTemplateFile;
    }(),
    // 打开导入对话框
    openImportDialog: function openImportDialog() {
      this.importDialogVisible = true;
      this.selectedFile = null;
      this.fileList = [];
    },
    // 处理文件选择
    handleFileChange: function handleFileChange(file, fileList) {
      this.selectedFile = file.raw;
      this.fileList = fileList;
    },
    // 导入数据
    importData: function () {
      var _importData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var formData, response, _t2;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (this.selectedFile) {
                _context3.next = 1;
                break;
              }
              this.$message.warning('请选择要上传的文件');
              return _context3.abrupt("return");
            case 1:
              formData = new FormData();
              formData.append('file', this.selectedFile);
              _context3.prev = 2;
              _context3.next = 3;
              return (0, _tableList.importTableData)(formData);
            case 3:
              response = _context3.sent;
              if (response.code === 200) {
                this.$message.success('导入成功');
                this.importDialogVisible = false;
                // 刷新表格数据
                this.getList();
              } else {
                this.$message.error(response.message || '导入失败');
              }
              _context3.next = 5;
              break;
            case 4:
              _context3.prev = 4;
              _t2 = _context3["catch"](2);
              this.$message.error('导入失败: ' + _t2.message);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[2, 4]]);
      }));
      function importData() {
        return _importData.apply(this, arguments);
      }
      return importData;
    }(),
    // 导出数据
    exportData: function () {
      var _exportData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var params, response;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (this.searchForm.storeId) {
                _context4.next = 1;
                break;
              }
              this.$message.warning('请先选择门店');
              return _context4.abrupt("return");
            case 1:
              this.$message.success('数据导出中...');
              params = {
                storeId: this.searchForm.storeId
              };
              _context4.next = 2;
              return (0, _tableList.exportTableCode)(params);
            case 2:
              response = _context4.sent;
              if (response && response.code === 0) {
                this.$message.success(response.message || '导出中，请稍后查看');
              } else {
                this.$message.error(response.message || '导出失败');
              }
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function exportData() {
        return _exportData.apply(this, arguments);
      }
      return exportData;
    }(),
    // 上线客位
    onlineSeats: function onlineSeats() {
      this.$message.success('客位上线成功');
    },
    // 同步客位
    pauseSeats: function pauseSeats() {
      (0, _tableList.syncSeat)(this.searchForm);
      this.$message.success('客位码正在同步，请稍后查看');
    },
    // 清空客位
    offlineSeats: function offlineSeats() {
      var _this6 = this;
      this.$confirm('确认清空所有客位吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _tableList.deleteTableSeat)().then(function () {
          _this6.$message.success('客位清空成功');
          _this6.getList();
        });
      });
    },
    // 编辑
    handleEdit: function handleEdit(row) {
      this.drawerForm = _objectSpread({}, row);
      this.drawerTitle = '编辑客位码';

      // 如果有二维码图片，设置文件列表
      if (row.qrCode) {
        this.fileList = [{
          name: '二维码.jpg',
          url: row.qrCode,
          uid: Date.now()
        }];
      } else {
        this.fileList = [];
      }
      this.drawerVisible = true;
    },
    // 添加客位码
    addGuest: function addGuest() {
      this.drawerForm = {
        id: null,
        storeName: '',
        seatName: '',
        seatArea: '',
        capacity: '',
        saleMode: '',
        qrCodeFile: null
      };
      this.drawerTitle = '添加客位码';
      this.drawerVisible = true;
    },
    // 关闭抽屉
    closeDrawer: function closeDrawer() {
      this.drawerVisible = false;
      this.resetForm();
    },
    // 重置表单
    resetForm: function resetForm() {
      this.drawerForm = {
        id: null,
        storeName: '',
        seatName: '',
        seatArea: '',
        capacity: '',
        saleMode: '',
        qrCodeFile: null
      };

      // 清空文件列表并释放内存
      this.fileList.forEach(function (file) {
        if (file.url && file.url.startsWith('blob:')) {
          URL.revokeObjectURL(file.url);
        }
      });
      this.fileList = [];
      if (this.$refs.drawerFormRef) {
        this.$refs.drawerFormRef.clearValidate();
      }
    },
    // 保存表单
    saveForm: function saveForm() {
      var _this7 = this;
      this.$refs.drawerFormRef.validate(function (valid) {
        if (valid) {
          // TODO: 实现保存逻辑
          console.log('保存数据:', _this7.drawerForm);
          _this7.$message.success('保存成功');
          _this7.closeDrawer();
        } else {
          _this7.$message.error('请填写完整信息');
        }
      });
    },
    // 文件上传处理
    handleFileUpload: function handleFileUpload(file) {
      // 验证文件类型
      var isImage = file.type.startsWith('image/');
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }

      // 验证文件大小
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 2MB!');
        return false;
      }

      // 保存文件并创建预览URL
      this.drawerForm.qrCodeFile = file;
      var previewUrl = URL.createObjectURL(file);
      this.fileList = [{
        name: file.name,
        url: previewUrl,
        uid: file.uid || Date.now()
      }];
      return false; // 阻止自动上传
    },
    // 删除文件
    handleFileRemove: function handleFileRemove(file, fileList) {
      this.drawerForm.qrCodeFile = null;
      this.fileList = [];
      // 释放预览URL内存
      if (file.url && file.url.startsWith('blob:')) {
        URL.revokeObjectURL(file.url);
      }
    },
    // 删除
    deleteEdit: function deleteEdit(row) {
      var _this8 = this;
      this.$confirm('确认删除该客位码吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 调用删除接口并等待结果
        (0, _tableList.deleteTable)({
          tableId: row.tableId
        }).then(function () {
          _this8.$message.success('删除成功');
          // 删除成功后刷新列表
          _this8.getList();
        }).catch(function (error) {
          _this8.$message.error('删除失败:' + error.message);
        });
      }).catch(function () {
        _this8.$message.info('已取消删除');
      });
    },
    // 分页大小改变
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1; // 改变每页大小时重置为第一页
      this.getList();
    },
    // 当前页改变
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    // 打开创建快餐客位码对话框 - 第一步：选择区域
    openFastTableDialog: function openFastTableDialog() {
      if (!this.searchForm.storeId) {
        this.$message.warning('请先选择门店');
        return;
      }
      this.fastTableForm.storeId = this.searchForm.storeId;
      this.selectedArea = null;
      this.newAreaForm.areaName = '';
      // 加载区域列表
      this.loadAreaList();
      this.areaSelectDialogVisible = true;
    },
    // 加载区域列表
    loadAreaList: function () {
      var _loadAreaList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res, _t3;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 1;
              return (0, _tableList.getAreaList)(this.searchForm.storeId);
            case 1:
              res = _context5.sent;
              this.areaList = res || [];
              _context5.next = 3;
              break;
            case 2:
              _context5.prev = 2;
              _t3 = _context5["catch"](0);
              console.error('加载区域列表失败:', _t3);
              this.areaList = [];
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function loadAreaList() {
        return _loadAreaList.apply(this, arguments);
      }
      return loadAreaList;
    }(),
    // 选择区域
    selectArea: function selectArea(area) {
      this.selectedArea = area;
    },
    // 创建新区域
    createNewArea: function createNewArea() {
      var _this9 = this;
      this.$refs.newAreaFormRef.validate(/*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(valid) {
          var params, res, _t4;
          return regeneratorRuntime.wrap(function (_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                if (valid) {
                  _context6.next = 1;
                  break;
                }
                return _context6.abrupt("return");
              case 1:
                _this9.creatingArea = true;
                _context6.prev = 2;
                params = {
                  storeId: _this9.searchForm.storeId,
                  areaName: _this9.newAreaForm.areaName + '区' // 自动拼接"区"
                };
                _context6.next = 3;
                return (0, _tableList.saveArea)(params);
              case 3:
                res = _context6.sent;
                if (!(res && (res.code === 0 || res.code === 200))) {
                  _context6.next = 5;
                  break;
                }
                _this9.$message.success('区域创建成功');
                _this9.newAreaForm.areaName = '';
                // 重新加载区域列表
                _context6.next = 4;
                return _this9.loadAreaList();
              case 4:
                _context6.next = 6;
                break;
              case 5:
                _this9.$message.error(res.message || '创建失败');
              case 6:
                _context6.next = 8;
                break;
              case 7:
                _context6.prev = 7;
                _t4 = _context6["catch"](2);
                _this9.$message.error('创建失败: ' + (_t4.message || '未知错误'));
              case 8:
                _context6.prev = 8;
                _this9.creatingArea = false;
                return _context6.finish(8);
              case 9:
              case "end":
                return _context6.stop();
            }
          }, _callee6, null, [[2, 7, 8, 9]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    // 确认选择区域，进入第二步
    confirmArea: function confirmArea() {
      if (!this.selectedArea) {
        this.$message.warning('请选择区域');
        return;
      }
      this.fastTableForm.area = this.selectedArea.areaName;
      this.areaSelectDialogVisible = false;
      this.fastTableDialogVisible = true;
    },
    // 关闭区域选择对话框
    closeAreaSelectDialog: function closeAreaSelectDialog() {
      this.areaSelectDialogVisible = false;
      this.selectedArea = null;
      this.newAreaForm.areaName = '';
    },
    // 关闭创建快餐客位码对话框
    closeFastTableDialog: function closeFastTableDialog() {
      this.fastTableDialogVisible = false;
      this.resetFastTableForm();
    },
    // 重置快餐客位码表单
    resetFastTableForm: function resetFastTableForm() {
      this.fastTableForm = {
        storeId: this.searchForm.storeId || '',
        area: '',
        startCode: 1,
        endCode: 20,
        excludeCodesText: '',
        prefix: '',
        skipExisting: true
      };
      this.selectedArea = null;
      if (this.$refs.fastTableFormRef) {
        this.$refs.fastTableFormRef.clearValidate();
      }
    },
    // 解析排除代码
    parseExcludeCodes: function parseExcludeCodes() {
      if (!this.fastTableForm.excludeCodesText) {
        return [];
      }
      return this.fastTableForm.excludeCodesText.split(',').map(function (code) {
        return parseInt(code.trim());
      }).filter(function (code) {
        return !isNaN(code);
      });
    },
    // 创建快餐客位码
    createFastTables: function createFastTables() {
      var _this0 = this;
      this.$refs.fastTableFormRef.validate(/*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(valid) {
          var params, response, _t5;
          return regeneratorRuntime.wrap(function (_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                if (valid) {
                  _context7.next = 1;
                  break;
                }
                return _context7.abrupt("return");
              case 1:
                _this0.fastTableCreating = true;
                _context7.prev = 2;
                params = {
                  storeId: _this0.fastTableForm.storeId,
                  area: _this0.fastTableForm.area,
                  startCode: _this0.fastTableForm.startCode,
                  endCode: _this0.fastTableForm.endCode,
                  excludeCodes: _this0.parseExcludeCodes(),
                  prefix: _this0.fastTableForm.prefix,
                  skipExisting: _this0.fastTableForm.skipExisting
                };
                _context7.next = 3;
                return (0, _tableList.createFastTables)(params);
              case 3:
                response = _context7.sent;
                if (response && (response.code === 0 || response.code === 200)) {
                  _this0.$message.success(response.message || '创建成功');
                  _this0.closeFastTableDialog();
                  _this0.getList();
                } else {
                  _this0.$message.error(response.message || '创建失败');
                }
                _context7.next = 5;
                break;
              case 4:
                _context7.prev = 4;
                _t5 = _context7["catch"](2);
                _this0.$message.error('创建失败: ' + (_t5.message || '未知错误'));
              case 5:
                _context7.prev = 5;
                _this0.fastTableCreating = false;
                return _context7.finish(5);
              case 6:
              case "end":
                return _context7.stop();
            }
          }, _callee7, null, [[2, 4, 5, 6]]);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  },
  mounted: function mounted() {
    // 初始化数据
  }
};